module.exports = __webpack_public_path__ + "static/media/nobu_hero.d7dd5485.png";